// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".entity_list_components-module__item--2_Xl3{margin:32px 0;display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex}.entity_list_components-module__icon--bRrEt{-webkit-align-self:flex-start;-ms-flex-item-align:start;align-self:flex-start}.entity_list_components-module__group--ixId4{margin-left:16px}.entity_list_components-module__subtitleBlock--2lhzV{font-weight:400;font-size:14px;line-height:21px;letter-spacing:0}\n", ""]);
// Exports
exports.locals = {
	"item": "entity_list_components-module__item--2_Xl3",
	"icon": "entity_list_components-module__icon--bRrEt",
	"group": "entity_list_components-module__group--ixId4",
	"subtitleBlock": "entity_list_components-module__subtitleBlock--2lhzV"
};
module.exports = exports;
